import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

function AuthCallback() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const searchParams = new URLSearchParams(location.search);
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (error) {
      // Handle OAuth error redirects from backend
      let message = t('errors.failed');
      
      if (error === 'redirect_uri_mismatch') {
        message = t('errors.redirectMismatch');
      } else if (error === 'not_configured') {
        message = t('errors.notConfigured');
      } else if (error === 'no_email') {
        message = t('errors.noEmail');
      } else if (error === 'no_code') {
        message = t('errors.noCode');
      } else if (errorDescription) {
        message = errorDescription;
      }
      
      toast.error(message);
      navigate('/login', { replace: true });
      return;
    }

    // No error, but no session established - this shouldn't happen
    // The backend will set the session cookie and redirect to dashboard
    // If we reach here, something went wrong
    navigate('/login', { replace: true });
  }, [navigate, location, t]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-700 mx-auto mb-4"></div>
        <p className="text-slate-600 dark:text-slate-400">{t('completing')}</p>
      </div>
    </div>
  );
}

export default AuthCallback;
